<!--
 * @Author: zhangliang
 * @Date: 2020-03-03 18:32:01
 * @LastEditTime: 2020-04-21 22:49:52
 * @LastEditors: zhangliang
 * @Description: 
 * @FilePath: \asset_app\src\views\ConsumableAnalyse.vue
 -->
<template>
  <div>
    <van-tabs
      v-model="active"
      @click="handleTabClick"
      title-active-color="#5A8DFF"
      color="#5A8DFF"
      sticky
    >
      <van-tab title="库存概况" name="depotSotck">
        <section class="inventory">
          <van-dropdown-menu active-color="#5A8DFF">
            <van-dropdown-item :title="selectedDepot.text" ref="dropdownDepot1">
              <div class="dropdown-option" 
              v-for="item in depotList" 
              :key="item.value"
              @click="handleDropdownDepotChange(item)">
                <span>{{item.text}}</span>
                <span :class="selectedDepot.value == item.value ? 'iconxuanzhong' : ''"></span>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
          <data-division
            :quantity-data="quantityData"
            :data-collapse-titles="collapseTitles"
            :group-data="group_data"
            @showQuestion="showQuestion"
          />
        </section>
      </van-tab>

      <van-tab title="领用统计" name="recipients">
        <section class="inventory">
          <van-dropdown-menu active-color="#5A8DFF">
            <van-dropdown-item :title="selectedDepot.text" ref="dropdownDepot2">
              <div class="dropdown-option" 
              v-for="item in depotList" 
              :key="item.value"
              @click="handleDropdownDepotChange(item)">
                <span>{{item.text}}</span>
                <span :class="selectedDepot.value == item.value ? 'iconxuanzhong' : ''"></span>
              </div>
            </van-dropdown-item>
            <van-dropdown-item :title="activeType.name" ref="dropdownType">
              <type-collapse :type-data="typeData" @dropdownToggle="dropdownToggle" />
            </van-dropdown-item>
          </van-dropdown-menu>
          <data-division
            :quantity-data="quantityData"
            :data-collapse-titles="collapseTitles"
            :group-data="group_data"
            @showQuestion="showQuestion"
          />
        </section>
      </van-tab>
    </van-tabs>

    <report-popup 
    :name="reportTitleName"
    :isShowQuestion="isShowQuestion" 
    @show="isShowQuestion=false" />
  </div>
</template>
<script>
import { fetch } from "../utils/http";
import store from "../store";
import TypeCollapse from "../components/TypeCollapse";
import ReportPopup from "../components/ReportPopup";
import DataDivision from "../components/DataDivision";
import { isInAppBrowser, messagePost } from "../utils/common";
import { Tabs, Tab, DropdownMenu, DropdownItem } from "vant";

export default {
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-dropdown-menu": DropdownMenu,
    "van-dropdown-item": DropdownItem,
    "report-popup": ReportPopup,
    "type-collapse": TypeCollapse,
    "data-division": DataDivision
  },
  computed: {
    // 当前选中的组织
    activeType() {
      return store.getters.getActiveType;
    },
    // 直属分类和组织弹出说明
    reportTitleName() {
      if (this.active === "depotSotck") {
        return 'consumable'
      } else {
        return 'organization'
      }
    }
  },
  data() {
    return {
      depotList: [], // 仓库下拉列表
      selectedDepot: {
        text: "全部仓库",
        value: 0
      }, // 仓库列表下拉框选中的值
      typeData: [], // 组织下拉列表
      collapseTitles: {}, // 列表头部数据
      quantityData: [], // 头部数据
      isShowQuestion: false, // 是否显示弹窗
      active: "depotSotck", // 当前tab
      group_data: [] // 下面数据组
    };
  },
  mounted() {
    messagePost("call_back_analyse");
    if (isInAppBrowser()) {
      window.passToken = res => {
        var token = JSON.parse(res).token;
        store.commit("setToken", token);
        this.getAllowDepot();
        this.getData();
      };
    } else {
      this.getAllowDepot();
      this.getData();
    }
  },
  methods: {
    // 切换顶部tab栏
    handleTabClick(name) {
      this.active = name;
      this.selectedDepot = {
        text: "全部仓库",
        value: 0
      }
      // 只有领用统计才会有组织选项
      if (this.active === "recipients") {
        this.getAllowConsumablesType();
      }
      this.getData();
    },
    // 选择仓库换下拉框
    handleDropdownDepotChange(item) {
      this.selectedDepot.value = item.value
      this.selectedDepot.text = item.text
      if (this.$refs.dropdownDepot1) {
        this.$refs.dropdownDepot1.toggle();
      }
      if (this.$refs.dropdownDepot2) {
        this.$refs.dropdownDepot2.toggle();
      }
      this.getData();
    },
    // 获取仓库列表
    getAllowDepot() {
      let defaultData = {
        text: "全部仓库",
        value: 0
      };
      fetch(`/common/getAllowDepot`).then(res => {
        if (res.code === "CODE_200") {
          this.depotList = [defaultData].concat(res.data);
        } else {
          this.depotList = [defaultData];
          this.$mmToast(res.msg || res.msg_arr);
        }
      });
    },
    // 获取耗材分类
    getAllowConsumablesType() {
      let defaultData = {
        disabled: false,
        id: 0,
        name: "全部分类"
      };
      store.commit("setActiveType", defaultData);
      fetch("/common/getAllowConsumablesType").then(res => {
        if (res.code === "CODE_200") {
          this.typeData = [defaultData].concat(res.data)
        } else {
          this.typeData = [defaultData]
          this.$mmToast(res.msg || res.msg_arr);
        }
        setIdAndActive(this.typeData);
      });
      let setIdAndActive = typeData => {
        typeData.id = 1;
        typeData.forEach(item => {
          if (item.children && item.children.length > 0) {
            setIdAndActive(item.children);
          }
        });
      };
    },
    // 收起组织选择下拉框
    dropdownToggle() {
      this.$refs.dropdownType.toggle();
      this.getData();
    },
    // 获取列表数据
    getData() {
      // 库存概况
      fetch(`/app/consumables/reports/${this.active}`, {
        depot_id: this.selectedDepot.value,
        type_id: this.active === "recipients" ? this.activeType.id : undefined
      }).then(res => {
        if (res.code === "CODE_200") {
          this.group_data = res.data.group_data;
          this._setTopDataAndTitle(res.data.top_data);
          this._setActiveName(this.group_data, 0);
        } else {
          this.$mmToast(res.msg || res.msg_arr);
        }
      });
    },
    // 设置头部数据和数据列表title
    _setTopDataAndTitle(top_data) {
      if (this.active === "depotSotck") {
        // 库存概况
        this.quantityData = [
          {
            title: "结存数量(件)",
            number: top_data.sum_stock_total || 0
          },
          {
            title: "本月入库量(件)",
            number: top_data.sum_month_in_total || 0
          },
          {
            title: "本月出库量(件)",
            number: top_data.sum_month_out_total || 0
          }
        ];
        this.collapseTitles = {
          // 库存概况下面数据title
          first: "耗材分类",
          second: "结存数量",
          third: "本月入库量",
          fourth: "本月出库量"
        };
      }
      if (this.active === "recipients") {
        // 领用统计
        this.quantityData = [
          {
            title: "本月领用量(件)",
            number: top_data.sum_current_month_total
          },
          {
            title: "金额(元)",
            number: top_data.sum_current_month_amount
          },
          {
            title: "上月领用量(件)",
            number: top_data.sum_prev_month_total
          }
        ];
        this.collapseTitles = {
          // 领用库统计下面数据title
          first: "领用组织",
          second: "本月领用量",
          third: "金额",
          fourth: "上月领用量"
        };
      }
    },
    // 数据换key并添加层级标识
    _setActiveName(arr, customLevel) {
      arr.forEach((item, index) => {
        // 添加自定义层级标识
        if (customLevel === 0) {
          item.customLevel = 1
        } else {
          item.customLevel = customLevel + 1
        }
        // 库存概况
        if (this.active === "depotSotck") {
          item.left = item.sum_stock_total;
          item.center = item.sum_month_in_total;
          item.right = item.sum_month_out_total;
        }
        // 领用统计
        if (this.active === "recipients") {
          item.left = item.sum_current_month_total;
          item.center = item.sum_current_month_amount;
          item.right = item.sum_prev_month_total;
        }
        // 设置第一行初始化展开
        // if (index === 0) {
        //   this.$set(arr, "activeId", item.id);
        // }
        if (item.children && item.children.length > 0) {
          this._setActiveName(item.children,item.customLevel);
        }
      });
    },
    // 点击问号
    showQuestion() {
      this.isShowQuestion = true;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .van-tab__text {
    font-size: 16PX;
}

.dropdown-option {
  height: 34PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16PX;
  font-size: 14PX;
  font-family:PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
}

// 库存概况下拉选项样式
::v-deep .van-tabs__content {
    .van-tab__pane:nth-of-type(1) {
        .inventory {
            background: #F4F6F8;
            padding-top: 10PX;
            // height: calc(100vh - 54PX);
            overflow: auto;
            .van-dropdown-menu {
                height: 40PX;
                .van-dropdown-menu__item {
                    justify-content: left!important;
                }
                .van-dropdown-menu__title {
                    padding-left: 32px;
                    font-size: 14PX;
                    max-width: calc(100vw - 60px);
                }
                .van-dropdown-item {
                    // top: 60PX!important;
                }
                .van-icon-success::before {
                    font-size: 24PX;
                }
                .van-cell {
                    justify-content: space-between;
                }
                .van-cell__title {
                    overflow: hidden; 
                    text-overflow: ellipsis;
                    white-space: nowrap; 
                    height: 24PX;
                    span {
                        white-space: nowrap;
                    }
                }
                .van-cell__value {
                    width: 30PX;
                    flex: 0 1 auto;
                    height: 24PX;
                }
            }
        }
    }
}

// 入库、出库统计下拉选项样式
::v-deep .van-tabs__content {
    .van-tab__pane:nth-of-type(2),.van-tab__pane:nth-of-type(3) {
        .inventory {
            background: #F4F6F8;
            padding-top: 10PX;
            // height: calc(100vh - 54PX);
            overflow: auto;
            .van-dropdown-menu {
                height: 40PX;
                .van-icon-success::before {
                    font-size: 24PX;
                }
                .van-cell__title {
                    height: 24PX;
                }
                .van-cell__value {
                    width: 30PX;
                    flex: 0 1 auto;
                    height: 24PX;
                }
            }
        }
        .van-dropdown-menu__item {
            justify-content: start;
            flex: none;
            max-width: calc(50vw - 50px);
            margin-right: 50px;
            .van-dropdown-menu__title {
                padding-left: 32px;
                font-size: 14PX;
                .van-ellipsis {
                    max-width: calc(50vw - 70px);
                }
            }
        }
    }
}
</style>